import { extendTheme } from '@chakra-ui/react';

const brand = {
  50: '#e6f7ff',
  100: '#b3e0ff',
  200: '#80caff',
  300: '#4db3ff',
  400: '#1a9dff',
  500: '#0080ff',
  600: '#0066cc',
  700: '#004d99',
  800: '#003366',
  900: '#001a33',
};

// High-contrast gray ramp: each *text* gray is shifted ~2 steps darker so
// every existing `color="gray.400/500/600"` call site lands at WCAG AA
// (≥4.5:1 on white) without touching the call sites themselves.
// Backgrounds/dividers (50–300) are left alone so surfaces stay light.
//   400: 2.5:1 → 7.0:1   500: 4.0:1 → 10.3:1   600: 5.9:1 → 14.6:1
const highContrastGray = {
  50: '#F7FAFC',
  100: '#EDF2F7',
  200: '#E2E8F0',
  300: '#CBD5E0',
  400: '#4A5568', // Chakra gray.600
  500: '#2D3748', // Chakra gray.700
  600: '#1A202C', // Chakra gray.800
  700: '#171923', // Chakra gray.900
  800: '#171923',
  900: '#171923',
};

export function makeTheme({ highContrast = false } = {}) {
  return extendTheme({
    fonts: {
      heading: 'Inter, sans-serif',
      body: 'Inter, sans-serif',
    },
    fontSizes: {
      // '2xs' is NOT a Chakra token — the ~59 fontSize="2xs" call sites
      // were emitting invalid CSS and silently inheriting the parent
      // size. Define it at the 12px accessibility floor (= xs) so they
      // render deterministically and scale with the root font-size.
      '2xs': '0.75rem',
    },
    config: {
      initialColorMode: 'light',
      useSystemColorMode: false,
    },
    colors: {
      brand,
      ...(highContrast ? { gray: highContrastGray } : {}),
    },
    ...(highContrast
      ? {
          styles: {
            global: {
              body: { color: 'gray.900' },
            },
          },
        }
      : {}),
  });
}

// Default (unmodified) theme — kept as the module default so existing
// `import theme from './theme'` call sites keep working.
const theme = makeTheme();

export default theme;
